export const isMetaBrowser = navigator.userAgent.includes('Instagram') ||
                             navigator.userAgent.includes('FBAN') ||
                             navigator.userAgent.includes('FBAV')
